export enum WatchlistCategoryType {
    PaymentDefault = 1,
    MaturityDefault = 2,
    ExtendedInterestDeferral = 3,
    UnapprovedLiens = 4,
    TitleIssue = 5,
    Litigation = 6,
    OutstandingOver24Months = 7,
    CompletionLessThan50Percentat180Days = 8,
    CompletionLessThan75PercentAt1Year = 9,
    Other = 10,
    NonAccrual = 11,
}

export const WatchlistCategoryTypeOptions = [
    {
        id: WatchlistCategoryType.PaymentDefault,
        name: 'Payment Default',
    },
    {
        id: WatchlistCategoryType.MaturityDefault,
        name: 'Maturity Default',
    },
    {
        id: WatchlistCategoryType.ExtendedInterestDeferral,
        name: 'Extended Interest Deferral',
    },
    {
        id: WatchlistCategoryType.UnapprovedLiens,
        name: 'Unapproved Liens',
    },
    {
        id: WatchlistCategoryType.TitleIssue,
        name: 'Title Issue',
    },
    {
        id: WatchlistCategoryType.Litigation,
        name: 'Litigation',
    },
    {
        id: WatchlistCategoryType.OutstandingOver24Months,
        name: 'Outstanding >24 Months',
    },
    {
        id: WatchlistCategoryType.CompletionLessThan50Percentat180Days,
        name: 'Completion, <50% at 180 days',
    },
    {
        id: WatchlistCategoryType.CompletionLessThan75PercentAt1Year,
        name: 'Completion, <75% at 1 year',
    },
    {
        id: WatchlistCategoryType.Other,
        name: 'Other',
    },
    {
        id: WatchlistCategoryType.NonAccrual,
        name: 'Non-Accrual',
    },
];
